var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#228BE6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.988 9.01a6.774 6.774 0 0 1-4.16-1.424 7.095 7.095 0 0 1-2.616-4.263A7.263 7.263 0 0 1 21.079 2h-4.46v12.492l-.006 6.843c0 1.83-1.162 3.38-2.773 3.926a3.961 3.961 0 0 1-3.345-.377 4.158 4.158 0 0 1-1.973-3.487c-.034-2.313 1.79-4.199 4.045-4.199.445 0 .873.075 1.273.21v-4.641a8.565 8.565 0 0 0-1.286-.098c-2.468 0-4.777 1.052-6.427 2.947a8.687 8.687 0 0 0-2.11 5.173c-.152 2.516.746 4.908 2.489 6.673A8.423 8.423 0 0 0 12.555 30a8.448 8.448 0 0 0 6.048-2.538 8.664 8.664 0 0 0 2.505-6.092l-.024-10.218a11.2 11.2 0 0 0 2.506 1.498 11.03 11.03 0 0 0 4.41.911V9.01h-.012z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.6295e12f7ccde40b36b03861ca1caa88.svg";
export { ForwardRef as ReactComponent };